import { render } from "./ShareWithGroupsForm.vue?vue&type=template&id=3b65ad53"
import script from "./ShareWithGroupsForm.vue?vue&type=script&lang=ts"
export * from "./ShareWithGroupsForm.vue?vue&type=script&lang=ts"
script.render = render

export default script